<mat-sidenav-content *ngIf="loader===false && user" autosize>
    <div>
        <app-sidebar></app-sidebar>
        <button class="app-toggle-btn"
                mat-icon-button (click)="sidebarHandler()">
            <mat-icon mat-list-icon>{{!openedSidebar ? 'keyboard_arrow_left' : 'keyboard_arrow_right'}}</mat-icon>
        </button>
    </div>


    <!--<div [ngStyle]="{'margin-left':marginLeft}" class="app-main-content overflow-hidde">-->
    <div class="app-main-content overflow-hidden px-2">
        <router-outlet></router-outlet>
    </div>
</mat-sidenav-content>

